/**
 * @generated SignedSource<<999e4f9a4112e31af0eaf3eb720c7b0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetDoNotShowAnswerTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  rootNodeId: string;
};
export type ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation$variables = {
  input: SetDoNotShowAnswerTreeConfigInput;
};
export type ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly setDoNotShowAnswerTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"ShowAnswerTreeConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation = {
  response: ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation$data;
  variables: ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetDoNotShowAnswerTreeConfigPayload",
                "kind": "LinkedField",
                "name": "setDoNotShowAnswerTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ShowAnswerTreeConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetDoNotShowAnswerTreeConfigPayload",
                "kind": "LinkedField",
                "name": "setDoNotShowAnswerTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "showAnswerConfig",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "AfterDateTimeDoShowAnswerTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c33ad4ee5d70808ee40999ce6083d7a",
    "id": null,
    "metadata": {},
    "name": "ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation",
    "operationKind": "mutation",
    "text": "mutation ShowAnswerTreeConfigEditor_SetDoNotShowAnswerTreeConfigMutation(\n  $input: SetDoNotShowAnswerTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      setDoNotShowAnswerTreeConfig(input: $input) {\n        rootNode {\n          ...ShowAnswerTreeConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment on AfterDateTimeDoShowAnswerTreeConfig {\n  id\n  configType\n  dateTime\n}\n\nfragment AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment ShowAnswerTreeConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      showAnswerConfig {\n        __typename\n        configType\n        ... on AfterDateTimeDoShowAnswerTreeConfig {\n          dateTime\n        }\n        ...AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment\n        id\n      }\n    }\n  }\n  ...AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "b39930062711423ff48bcf8094a4b6cd";

export default node;
